export default "__VITE_ASSET__eee3f8ab__"